import { useState, useCallback } from 'react';

export interface RoundTripTimeState {
  /** Latest RTT in milliseconds, or null if no measurement yet */
  latestRtt: number | null;
  /** Timestamp for when the latest RTT was measured, in epoch milliseconds */
  lastMeasuredAt: number | null;
  /** Update the RTT value */
  updateRtt: (rtt: number) => void;
}

/**
 * Hook to manage Round-Trip Time (RTT) measurements.
 * Stores the latest RTT value from API calls.
 */
export function useRoundTripTime(): RoundTripTimeState {
  const [latestRtt, setLatestRtt] = useState<number | null>(null);
  const [lastMeasuredAt, setLastMeasuredAt] = useState<number | null>(null);

  const updateRtt = useCallback((rtt: number) => {
    setLatestRtt(rtt);
    setLastMeasuredAt(Date.now());
  }, []);

  return {
    latestRtt,
    lastMeasuredAt,
    updateRtt,
  };
}
